







































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Common } from "@/lib/Common/Guid";
import ControlDto from "@/store/entities/devices/switchs/controldto";
import PageRequest from "@/store/entities/page-request";

class PageMeterRequest extends PageRequest {
  switchId: any[] = [];
  keyword: string;
}

@Component({
  components: { TreeSelect },
})
export default class AuthorizationSwitch extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) switchId: any[];
  @Prop({ type: Array, default: [] }) switchNo: any[];

  pagerequest: PageMeterRequest = new PageMeterRequest();
  entity: ControlDto = new ControlDto();
  loading: boolean = false;
  isupdate: boolean = false; //是否更新
  list: any[] = []; //记录
  totalCount: number = 0; //总记录数
  currentPage: number = 1; //页数
  pageSize: number = 5; //每页记录数

  async created() { }
  //保存
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.entity.switchId = this.switchId;
        let res = await this.$store
          .dispatch({
            type: "switchs/switchAuthorization",
            data: this.entity,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res,
        });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();
    this.$emit("input", false);
  }
  //删除授权用户
  async deleteuser() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.entity.switchId = [];
    val.forEach((ele) => {
      this.entity.switchId.push(ele.id);
    });
    let res = await this.$store
      .dispatch({
        type: "switchs/deleteAuthorizationUser",
        data: this.entity,
      })
      .catch((err) => {
        this.loading = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.loading = false;
    this.getpage();
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getpage();
    }
  }
  pageChange(page: number) {
    this.currentPage = page;
    // this.$store.commit("switchs/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    //this.$store.commit("switchs/setPageSize", pagesize);
    this.pageSize = pagesize;
    this.getpage();
  }
  //获取数据
  async getpage() {
    //console.log(this.pagerequest);
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    let res = await this.$store.dispatch({
      type: "switchs/switchAuthorizationUser",
      data: this.pagerequest,
    });
    this.list = [];
    this.totalCount = 0;
    if (res != null) {
      this.list = res.items;
      this.totalCount = res.totalCount;
    }
  }
  //改变排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列名
  columns = [
    {
      type: "index",
      width: 80,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      type: "selection",
      width: 40,
      align: "left",
      fixed: "left",
      sortId: 1,
    },
    {
      sortable: true,
      title: this.L("DeviceNo"),
      key: "deviceNo",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("Surname"),
      key: "sureName",
      resizable: true,
      width: 130,
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.sureName,
            },
          },
          params.row.sureName
        );
      },
    },
    {
      sortable: true,
      title: this.L("Mobile"),
      key: "mobile",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.mobile,
            },
          },
          params.row.mobile
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      sortable: true,
      resizable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      resizable: true,
      sortId: 4,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      resizable: true,
      sortId: 18,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
  ];
  modelRule = {
    mobile: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("switchId", { deep: true })
  @Watch("switchNo", { deep: true })
  getitemId() {
    this.entity.switchId = this.switchId;
    this.entity.switchNo = "";
    this.pagerequest.switchId = this.switchId;
    this.switchNo.forEach((ele) => {
      if (this.entity.switchNo.length == 0) {
        this.entity.switchNo = ele;
      } else {
        this.entity.switchNo = this.entity.switchNo + ";" + ele;
      }
    });
  }
}
